export default __webpack_public_path__ + "static/media/02.15.24 Minutes of the Special Meeting of the BOD.9cb8d2d1.pdf";